import {
	GET_SURVEY_PAGE_REQUEST,
	GET_SURVEY_PAGE_SUCCESS,
	GET_SURVEY_PAGE_ERROR,
	SURVEY_SAVE_SUCCESS,
	SURVEY_GO_PREV,
	SURVEY_GO_NEXT,
	SURVEY_COMPLETE_SUCCESS,
	SURVEY_SAVE_REQUEST
} from 'actions/surveyPageActions';
import { INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
import {
	getFirstUnansweredQuestion,
	getLocalVisibleQuestions,
	getPrevQuestion,
	getNextQuestion,
	hasPrevQuestion,
	hasNextQuestion,
	getProgress
} from './utils';

const defaultState = {
	asyncStatus: INIT,
	contextData: null,
	thankYouMessage: null,
	surveyData: null,
	isStarted: null,
	isCompleted: null,
	progress: null,
	currentItem: null,
	hasPrev: null,
	hasNext: null,
	localAnswers: {},
	answering: false,
	localVisibleQuestions: {}
};

export default function surveyState(state = { asyncStatus: INIT }, action) {
	let sections,
		nodes,
		hasPrev,
		hasNext,
		nextQuestion,
		currentQuestionId,
		localVisibleQuestions,
		localAnswers,
		thankYouMessage,
		progress;

	switch (action.type) {
		case GET_SURVEY_PAGE_REQUEST:
			return Object.assign({}, defaultState);
		case SURVEY_SAVE_REQUEST:
			return Object.assign({}, state, { answering: true });
		case GET_SURVEY_PAGE_SUCCESS:
			const surveyData = action.data.surveyData;
			const isCompleted = surveyData.is_survey_complete;
			sections = get(surveyData, ['content', 'sections'], []);
			nodes = get(surveyData, ['nodes'], {});
			const firstQuestion = getFirstUnansweredQuestion(sections, nodes);
			hasPrev = isCompleted ? false : hasPrevQuestion(firstQuestion, sections, nodes);
			hasNext = isCompleted ? false : hasNextQuestion(firstQuestion, sections, nodes);
			thankYouMessage = isCompleted ? get(surveyData, ['end_confirmation']) : null;
			progress = getProgress(sections, nodes);
			return Object.assign({}, defaultState, {
				asyncStatus: SUCCESS,
				contextData: action.data.contextData,
				surveyData: surveyData,
				currentItem: firstQuestion,
				hasPrev: hasPrev,
				hasNext: hasNext,
				isCompleted: isCompleted,
				progress: progress,
				thankYouMessage: thankYouMessage
			});
		case SURVEY_SAVE_SUCCESS:
			const responses = action.data.responses;
			localAnswers = Object.assign({}, state.localAnswers);
			responses.forEach(item => {
				localAnswers[item['node_id']] = item.response;
			});
			const lastAnsweredQuestionId = get(responses, [responses.length - 1, 'node_id']);
			sections = state.surveyData.content.sections;
			nodes = state.surveyData.nodes;
			localVisibleQuestions = getLocalVisibleQuestions(state.localVisibleQuestions, responses, nodes);
			nextQuestion = getNextQuestion(lastAnsweredQuestionId, sections, nodes, localAnswers, localVisibleQuestions);
			hasPrev = hasPrevQuestion(nextQuestion, sections, nodes);
			hasNext = hasNextQuestion(nextQuestion, sections, nodes);
			progress = getProgress(sections, nodes, localAnswers);
			return Object.assign({}, state, {
				localVisibleQuestions: localVisibleQuestions,
				localAnswers: localAnswers,
				currentItem: nextQuestion,
				hasPrev: hasPrev,
				hasNext: hasNext,
				progress: progress,
				answering: false,
				isCompleted: !(hasPrev || hasNext)
			});
		case SURVEY_GO_NEXT:
			currentQuestionId = state.currentItem.question;
			sections = state.surveyData.content.sections;
			nodes = state.surveyData.nodes;
			localVisibleQuestions = state.localVisibleQuestions;
			localAnswers = state.localAnswers;
			nextQuestion = getNextQuestion(currentQuestionId, sections, nodes, localAnswers, localVisibleQuestions);
			hasPrev = hasPrevQuestion(nextQuestion, sections, nodes, localAnswers, localVisibleQuestions);
			hasNext = hasNextQuestion(nextQuestion, sections, nodes, localAnswers, localVisibleQuestions);
			progress = getProgress(sections, nodes, localAnswers);
			return Object.assign({}, state, {
				currentItem: nextQuestion,
				hasPrev: hasPrev,
				hasNext: hasNext,
				progress: progress,
				isCompleted: !(hasPrev || hasNext)
			});
		case SURVEY_GO_PREV:
			currentQuestionId = state.currentItem.question;
			sections = state.surveyData.content.sections;
			nodes = state.surveyData.nodes;
			localVisibleQuestions = state.localVisibleQuestions;
			localAnswers = state.localAnswers;
			const prevQuestion = getPrevQuestion(currentQuestionId, sections, nodes, localVisibleQuestions);
			hasPrev = hasPrevQuestion(prevQuestion, sections, nodes, localAnswers, localVisibleQuestions);
			hasNext = hasNextQuestion(prevQuestion, sections, nodes, localAnswers, localVisibleQuestions);
			return Object.assign({}, state, {
				currentItem: prevQuestion,
				hasPrev: hasPrev,
				hasNext: hasNext
			});
		case SURVEY_COMPLETE_SUCCESS:
			thankYouMessage = get(action.data, ['surveyData', 'end_confirmation']);
			return Object.assign({}, state, {
				isCompleted: true,
				thankYouMessage: thankYouMessage
			});
		case GET_SURVEY_PAGE_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error
			});
		default:
			return state;
	}
}
